<div [@bannerState]="state">
  <p-messages class="ses-message" *ngIf="isMessagesVisible" [value]="messages" (valueChange)="onMessagesClosed($event)"></p-messages>
</div>
